import VueRouter, { RouteConfig } from 'vue-router'

const CompetitionAreaList = () => import('@/views/CompetitionAreaList.vue')

const RCompetitionArea: RouteConfig[] = [
  {
    path: '/competition-area-list',
    name: 'competition_area_list',
    component: CompetitionAreaList,
    props: (route) => ({ ...route.query, ...route.params }),
    meta: {
      title: '省市级比赛',
    },
  },
]

export default RCompetitionArea

export function navigateToCompetitionAreaList(router: VueRouter) {
  router.push({ name: 'competition_area_list' })
}
